import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplatesCardsComponent } from '../components/templates-cards/templates-cards.component';
import { GlobalStore } from 'src/app/store/global-store';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
    selector: 'que-templates-page',
    imports: [CommonModule, TemplatesCardsComponent, TranslateDirective, TranslatePipe],
    templateUrl: './templates-page.component.html',
    styleUrls: ['./templates-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplatesPageComponent {
  #router = inject(Router)
  #global = inject(GlobalStore)

  back() {
    this.#router.navigate(["main"]);
  }
}
